import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const LensesStatusTitle = styled.div`
    display: flex;
    align-items: center;

    font-size: 11px;
    font-weight: 500;
    line-height: 12px;
    color: ${Colors.Black.V200};
    letter-spacing: 0.2px;
`;

export const LensStatusIndicator = styled.div<{ background: string; size?: number; marginRight?: number }>`
    width: ${({ size = 8 }) => `${size}px`};
    min-width: ${({ size = 8 }) => `${size}px`};
    height: ${({ size = 8 }) => `${size}px`};
    min-height: ${({ size = 8 }) => `${size}px`};
    margin-right: ${({ marginRight = 4 }) => `${marginRight}px`};

    background: ${({ background }) => background};
    border-radius: 8px;
`;

export const WarningSection = styled.div`
    display: inline-flex;
    align-items: center;
    padding-right: 4px;
    padding-left: 4px;
`;

export const CONTAINER_HEIGHT = 25;

export const LensStatusWithWarningContainer = styled.div<{ height?: number }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: ${({ height = CONTAINER_HEIGHT }) => `${height}px`};
`;
